'use strict';

mpro.addInitStatic(async ($container) => {

    const $productDesigner = $container.find('[data-product-designer]');

    // Init lib only if we need to
    if ($productDesigner.length > 0) {

        // Load rangeslider before the product designer
        await import('rangeslider.js');

        const [,sharedObjects,productDesigner] = await Promise.all([
            // import('../../mpro/modules/mpro.file-upload'),
            import('../../mpro/modules/mpro.image-processing.js'),
            import('../../vendor/product-designer/shared-objects'),
            import('../../vendor/product-designer/product-designer'),
        ]);

        // import('../../mpro/modules/mpro.file-upload'),
        // Init product designer
        productDesigner.UI.elements.layouts = $productDesigner.last().data('layouts');
        productDesigner.UI.elements.media = $productDesigner.last().data('media');
        let $webfonts = $productDesigner.last().data('webfonts');
        if (Object.keys($webfonts).length) {
            productDesigner.UI.elements.fonts = productDesigner.UI.elements.fonts.concat($.map($webfonts, function(v){
                return {'name': v.family, 'id': v.family.replaceAll(' ', ''), 'type': 'webfont'};
            }));
        }
        productDesigner.init();
    }
});